// Generated by ReScript, PLEASE EDIT WITH CARE


function fromString(filter) {
  if (filter === undefined) {
    return ;
  }
  switch (filter) {
    case "Bias" :
        return /* Bias */2;
    case "Fetcher" :
        return /* Fetcher */0;
    case "Filter" :
        return /* Filter */1;
    default:
      return ;
  }
}

function toString(filterType) {
  switch (filterType) {
    case /* Fetcher */0 :
        return "Fetcher";
    case /* Filter */1 :
        return "Filter";
    case /* Bias */2 :
        return "Bias";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
